import { UserWatchedQuotePostRequestBody } from '@lio/api-types';

import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useDeleteWatchedQuote = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const mutationFn = ({ quoteId, userId }: UserWatchedQuotePostRequestBody) => {
    const url = `user/${userId}/watched-quote/${quoteId}`;
    return client.delete(url);
  };
  const queryKey = ['quotes'];
  const result = useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
      queryClient.invalidateQueries({ queryKey: ['searchUserQuotes'] });
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
  return { ...result, deleteWatchedQuote: result.mutate };
};
